// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"7d0fc114","677":"7d0fc114"}[chunkId] + ".chunk.css";
};